import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-blog-shell',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './blog-shell.component.html',
  styleUrls: ['./blog-shell.component.css']
})
export class BlogShellComponent {
  @Input() blogId!: string;
  @Input() darkMode = false;

  constructor() {}
}
